import styles from './styles.module.scss'

const formatDate = dateString => {
  if (!dateString) return '-'
  // SubmissionTransformer already returns d-m-Y, H:i:s
  if (/^\d{2}[-.]\d{2}[-.]\d{4}/.test(String(dateString))) {
    return String(dateString)
  }
  try {
    return new Date(dateString).toLocaleString('uk-UA', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    })
  } catch (e) {
    return dateString
  }
}

const InfoCell = ({ label, children }) => (
  <div className={styles.cell}>
    <span className={styles.label}>{label}</span>
    <span className={styles.value}>{children}</span>
  </div>
)

export const SubmissionInfo = ({ data }) => {
  if (!data) return null

  const statusClass = styles[data.status?.toLowerCase()] || ''
  const contact = data.contact_email || data.contact_name || '-'
  const formName = data.form_name || data.form_id || data.form || '-'

  return (
    <section className={styles.section}>
      <h2 className={styles.title}>Submission Information</h2>
      <div className={styles.grid}>
        <InfoCell label='Submission ID'>{data.id || '-'}</InfoCell>
        <InfoCell label='Cognito Entry ID'>{data.cognito_entry_id || '-'}</InfoCell>
        <InfoCell label='Status'>
          <span className={`${styles.status} ${statusClass}`}>{data.status_label || data.status || '-'}</span>
        </InfoCell>

        <InfoCell label='Form'>{formName}</InfoCell>
        <InfoCell label='Contact'>{contact}</InfoCell>
        <InfoCell label='Created'>{formatDate(data.created_at)}</InfoCell>

        <InfoCell label='Updated'>{formatDate(data.updated_at)}</InfoCell>
        <InfoCell label='Sync Attempts'>{data.sync_attempts ?? 0}</InfoCell>
        <InfoCell label='Synced At'>{formatDate(data.synced_at)}</InfoCell>
      </div>

      {data.sync_error ? (
        <div className={styles.error}>
          <span className={styles.label}>Sync Error</span>
          <span className={styles.errorText}>{data.sync_error}</span>
        </div>
      ) : null}
    </section>
  )
}
